import { Component } from 'shimmer'

import gsap from 'gsap'

import { Box3, Vector3 } from 'three'

import cameraPositions from '@/assets/data/cameras'
import { FitTo } from '@/utils/FitTo'

import { emitter } from '@/utils/emitter'

export class CameraMovement {
  constructor (sceneScreen, avatarScene, camera) {
    // super()
    this.sceneScreen = sceneScreen
    this.avatarScene = avatarScene
    this.camera = camera

    this.fitTo = new FitTo(this.camera)

    this.computeObject = this.computeObject.bind(this)
    this.onEvent = this.onEvent.bind(this)
    this.onResize = this.onResize.bind(this)

    this.box = new Box3(new Vector3(-450 , 0, 0), new Vector3(300, 400, 250))
    this.onEvent('camFront')

    emitter.on('animation', this.onEvent)
  }

  computeObject () {
    const screen = this.sceneScreen.getObjectByName('screen')
    const avatar = this.avatarScene.getObjectByName('Head_01')

    if (!screen || !avatar) { return }

    screen.updateMatrixWorld(true)
    avatar.updateMatrixWorld(true)

    this.box = new Box3().makeEmpty()

    this.box.expandByObject(screen)
    this.boxScreen = this.box.clone()
    this.box.expandByObject(avatar)
  }

  onEvent (eventName) {
    const cameraPos = cameraPositions[eventName]
    if (cameraPos) {
      this.cameraPosName = eventName
      this.computeObject()

      const box = cameraPos.boxScreenOnly ? this.boxScreen : this.box
      const { position, look } = this.fitTo.fit(box, cameraPos.marg, {vector: new Vector3(cameraPos.vector.x, cameraPos.vector.y, cameraPos.vector.z)})

      // gsap.killTweensOf(this.camera.position, 'x,y,z')
      // gsap.killTweensOf(this.camera.look, 'x,y,z')

      gsap.to(this.camera.position, {
        x: position.x,
        y: position.y,
        z: position.z,
        duration: 2,
        ease: 'power2.inOut'
      })

      gsap.to(this.camera.look, {
        x: look.x,
        y: look.y,
        z: look.z,
        duration: 2,
        ease: 'power2.inOut',
        onUpdate: () => {
          this.camera.forceUpdateLook = true
        }
      })
    }
  }

  onResize () {
    this.computeObject()
    this.onEvent(this.cameraPosName)
  }
}
